import React, { useCallback, useEffect, useState } from "react";
import { Alert, Container, Spinner } from "reactstrap";
import BreadCrumb from "Components/Common/BreadCrumb";
import { useParams, useLocation } from "react-router-dom";
import { getLTA } from "common/services/ltas.service";
import { normalize } from "common/lib/normalize";
import { usePageActivity } from "Components/Hooks/UsePageActivity";
import LTAContent from "./LTAContent";

const ViewLTA = () => {
  const location = useLocation();
  const { id: ltaId } = useParams();
  usePageActivity(location.pathname, "View LTA", ltaId);

  const [lta, setLta] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const fetchLta = useCallback(async () => {
    setLoading(true);
    setError(false);
    try {
      const response: any = await getLTA(ltaId, {});
      setLta(normalize(response.data));
    } catch (e) {
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [ltaId]);

  useEffect(() => {
    fetchLta();
  }, [fetchLta]);

  document.title = "LTA Details | CIMS";

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="LTA Details"
          pageTitles={[
            { title: "Dashboard", link: "/" },
            { title: "LTAs", link: "/ltas" },
          ]}
          back
        />

        {loading && (
          <div className="text-center py-5">
            <Spinner color="primary" />
          </div>
        )}

        {!loading && error && (
          <Alert color="danger">
            This agreement could not be loaded. It may have been deleted, or you
            may not have permission to view it.
          </Alert>
        )}

        {!loading && !error && lta && (
          <LTAContent lta={lta} onChanged={fetchLta} />
        )}
      </Container>
    </div>
  );
};

export default ViewLTA;
